import React from "react";
import { ShieldCheck, Mail } from "lucide-react";
import InnovationHubHeader from "../components/InnovationHubHeader";
import InnovationHubFooter from "../components/InnovationHubFooter";

// Bu sayfa statiktir; veriler Firebase üzerinden okunmaz.
const content = [
  {
    "type": "heading",
    "text": "Kişisel Verilerinizi İşleyen Veri Sorumlusu"
  },
  {
    "type": "paragraph",
    "text": "İzmir Özel Türk Koleji Okulları içinde yer alan:"
  },
  {
    "type": "emphasis",
    "text": "TATIŞ EĞİTİM VE ÖĞRETİM İŞLETMECİLİĞİ TİC. VE SAN. A.Ş."
  },
  {
    "type": "paragraph",
    "text": "6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında veri sorumlusudur."
  },
  {
    "type": "paragraph",
    "text": "İzmir Özel Türk Koleji bünyesinde yer alan veri sorumluları işbu Aydınlatma Metninde genel olarak “İTK Starter” olarak anılacaktır."
  },
  {
    "type": "paragraph",
    "text": "İTK Starter, KVKK’nın 10 uncu maddesi ile Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ kapsamında işbu Aydınlatma Metnini bilgilerinize sunmaktadır."
  },
  {
    "type": "paragraph",
    "text": "İşbu Aydınlatma Metni; İTK Starter Kurum İçi Girişimcilik Programı ile Araştırma Projeleri kapsamında gerçekleştirilen başvuru, değerlendirme, eğitim, mentorluk, araştırma, etkinlik, iletişim ve benzeri süreçlerde işlenen kişisel verilere ilişkindir."
  },
  {
    "type": "heading",
    "text": "İşlenen Kişisel Veriler"
  },
  {
    "type": "paragraph",
    "text": "İTK Starter kapsamındaki süreçlere bağlı olarak aşağıdaki kişisel veriler işlenebilmektedir:"
  },
  {
    "type": "bullet",
    "text": "Ad, soyad ve iletişim bilgileri"
  },
  {
    "type": "bullet",
    "text": "Okul, kampüs ve sınıf seviyesi; çalışanlar için birim, departman ve unvan; dışarıdan başvuru yapan araştırmacı / akademisyenler için kurum, görev ve akademik unvan bilgileri"
  },
  {
    "type": "bullet",
    "text": "Veli / yasal temsilci bilgileri ile veli, okul müdürü, yönetici ve gerekli diğer izin / onay kayıtları"
  },
  {
    "type": "bullet",
    "text": "Ekip üyeleri, proje paydaşları, araştırma ekibi / danışmanları ve bunların proje içindeki rol bilgileri"
  },
  {
    "type": "bullet",
    "text": "Proje, girişim veya araştırma başvurusuna ilişkin ad / başlık, konu, amaç, kapsam, problem / araştırma sorusu, çözüm, yöntem, hedef / örneklem grubu, takvim, ihtiyaçlar ve beklenen çıktılara ilişkin bilgiler"
  },
  {
    "type": "bullet",
    "text": "Sunum, proje / araştırma önerisi, özgeçmiş, rapor, görsel, veri toplama aracı, izin / etik belge ve diğer başvuru veya proje ekleri"
  },
  {
    "type": "bullet",
    "text": "Eğitim, mentorluk, toplantı, araştırma takibi ve diğer program faaliyetlerine ilişkin katılım, süreç ve ilerleme bilgileri"
  },
  {
    "type": "bullet",
    "text": "Mentor, eğitmen, jüri, Değerlendirme Komitesi ve araştırma projesi değerlendiricilerinin değerlendirme, puanlama, geri bildirim ve yönlendirme bilgileri"
  },
  {
    "type": "bullet",
    "text": "Demo Day / final süreci, program sonucu, sertifika ve ödül bilgileri ile araştırma sonuçları, final raporları, whitepaper ve diğer proje çıktıları"
  },
  {
    "type": "bullet",
    "text": "Anket ve süreç değerlendirme cevapları"
  },
  {
    "type": "bullet",
    "text": "Proje / fikir sahipliği, araştırma yazarlığı / katkı bilgileri ve fikri mülkiyete ilişkin bilgiler"
  },
  {
    "type": "bullet",
    "text": "E-posta, talep, destek, bildirim ve diğer iletişim kayıtları"
  },
  {
    "type": "bullet",
    "text": "IP adresi, erişim bilgileri ve sistem log kayıtları"
  },
  {
    "type": "bullet",
    "text": "Açık rıza, sözleşme, imza, paylaşım / yayın izni ile araştırma veya program sürecine ilişkin diğer izin ve onay kayıtları"
  },
  {
    "type": "paragraph",
    "text": "İTK Starter programının olağan yürütülmesi kapsamında ihtiyaç bulunmayan kişisel verilerin toplanmaması esastır."
  },
  {
    "type": "paragraph",
    "text": "Araştırma Projeleri kapsamında araştırmaya katılan üçüncü kişilerden kişisel veya özel nitelikli kişisel veri toplanmasının planlanması halinde, söz konusu veri işleme faaliyeti bu genel Aydınlatma Metninden ayrı olarak ilgili araştırmanın niteliğine uygun şekilde değerlendirilir ve gerekli aydınlatma, izin, açık rıza ve diğer hukuki süreçler ayrıca yürütülür."
  },
  {
    "type": "heading",
    "text": "Kişisel Verilerinizi Hangi Amaçlarla İşlemekteyiz?"
  },
  {
    "type": "paragraph",
    "text": "Kişisel verileriniz;"
  },
  {
    "type": "number",
    "text": "İTK Starter girişimcilik programı ve Araştırma Projeleri başvurularının alınması, başvuru sahiplerinin programa uygunluğunun değerlendirilmesi ve başvuru sonuçlarının yönetilmesi,",
    "number": 1
  },
  {
    "type": "number",
    "text": "Katılımcı, araştırmacı, ekip, proje, girişim ve araştırma bilgilerinin kayıt altına alınması; başvurular kapsamında sunulan proje, araştırma, sunum, rapor ve diğer belgelerin incelenmesi, değerlendirilmesi, izlenmesi ve sonuçlandırılması,",
    "number": 2
  },
  {
    "type": "number",
    "text": "Eğitim, mentorluk, toplantı, jüri, Değerlendirme Komitesi, Demo Day ve benzeri program faaliyetlerinin planlanması ve yürütülmesi; katılım ve proje/araştırma gelişiminin takip edilmesi,",
    "number": 3
  },
  {
    "type": "number",
    "text": "Mentor, eğitmen, jüri ve Değerlendirme Komitesi tarafından gerçekleştirilen değerlendirme, puanlama, geri bildirim ve yönlendirme süreçlerinin yürütülmesi,",
    "number": 4
  },
  {
    "type": "number",
    "text": "Araştırma Projeleri kapsamında araştırmanın amacı, kapsamı, yöntemi, araştırma ekibi, hedef/örneklem grubu, gerekli izin/onay süreçleri ve araştırma çıktılarının değerlendirilmesi; kabul edilen çalışmaların takip edilmesi ve sonuçlarının rapor, final raporu veya whitepaper gibi formatlarda oluşturulması,",
    "number": 5
  },
  {
    "type": "number",
    "text": "Katılımcılar, araştırmacılar, veliler/yasal temsilciler, eğitmenler, mentorlar, değerlendiriciler, jüri üyeleri ve program yürütücüleri ile iletişimin sağlanması; duyuru, bilgilendirme, talep, soru, öneri ve şikâyet süreçlerinin yönetilmesi,",
    "number": 6
  },
  {
    "type": "number",
    "text": "Veli, okul müdürü veya ilgili yönetici izin/onay süreçleri ile programa ilişkin sözleşme, taahhüt ve diğer kayıt süreçlerinin yürütülmesi,",
    "number": 7
  },
  {
    "type": "number",
    "text": "Proje ve araştırmaların gizliliğinin, proje/fikir sahipliğinin ve fikri ve sınai mülkiyet haklarının korunması; program kurallarına ve İTK prosedürlerine uyumun takip edilmesi,",
    "number": 8
  },
  {
    "type": "number",
    "text": "Programın tamamlanması, Demo Day, sertifikalandırma ve gerekli olması halinde ödüllendirme süreçlerinin yürütülmesi,",
    "number": 9
  },
  {
    "type": "number",
    "text": "Gerekli olması halinde başarılı proje veya girişimlerin yatırım ve iş birliği olanakları bakımından değerlendirilmesi ve ilgili süreçlerin yürütülmesi,",
    "number": 10
  },
  {
    "type": "number",
    "text": "İTK Starter programının performansının ölçülmesi, katılımcı deneyiminin değerlendirilmesi, programın raporlanması ve geliştirilmesi,",
    "number": 11
  },
  {
    "type": "number",
    "text": "İTK Starter online platformunun ve program kapsamında kullanılan dijital sistemlerin işletilmesi, kullanıcı erişimlerinin yönetilmesi, bilgi ve sistem güvenliğinin sağlanması ve log kayıtlarının tutulması,",
    "number": 12
  },
  {
    "type": "number",
    "text": "İTK Starter kapsamında gerçekleştirilen eğitim, etkinlik, Demo Day ve benzeri faaliyetlerin kayıt altına alınması ve gerekli izin/açık rıza süreçlerinin tamamlanması kaydıyla programın, katılımcı projelerinin, araştırma çıktılarının, başarıların ve etkinliklerin İTK internet sitesi, sosyal medya hesapları ve diğer kurumsal iletişim kanallarında tanıtılması ve duyurulması,",
    "number": 13
  },
  {
    "type": "number",
    "text": "Araştırma Projeleri kapsamında oluşturulan araştırma çıktılarının ve whitepaper çalışmalarının, kişisel verilerin korunmasına ilişkin gerekli tedbirler alınarak ve gerektiğinde anonimleştirme veya ilgili izin süreçleri tamamlanarak yayımlanması ve paylaşılması,",
    "number": 14
  },
  {
    "type": "number",
    "text": "Girişim projeleri bakımından gerekli olması halinde ödül, yatırım ve iş birliği süreçlerinin değerlendirilmesi ve yürütülmesi",
    "number": 15
  },
  {
    "type": "number",
    "text": "Hukuki uyuşmazlıkların takibi, bir hakkın tesisi, kullanılması veya korunması ile yetkili kamu kurum ve kuruluşlarından gelen hukuka uygun taleplerin karşılanması,",
    "number": 16
  },
  {
    "type": "number",
    "text": "Kişisel verilerin korunması ve ilgili mevzuattan doğan yükümlülüklerin yerine getirilmesi",
    "number": 17
  },
  {
    "type": "paragraph",
    "text": "amaçlarıyla işlenmektedir."
  },
  {
    "type": "paragraph",
    "text": "Kişisel verileriniz, işleme amaçlarının gerektirdiği süre boyunca ve ilgili mevzuatta öngörülen saklama sürelerine uygun olarak muhafaza edilir; işlenmesini gerektiren sebeplerin ortadan kalkması halinde KVKK ve ilgili mevzuat uyarınca silinir, yok edilir veya anonim hale getirilir."
  },
  {
    "type": "heading",
    "text": "Kişisel Verilerinizi Hangi Hukuki Sebebe Dayanarak ve Ne Şekilde Toplamaktayız?"
  },
  {
    "type": "paragraph",
    "text": "Kişisel verileriniz; İTK Starter internet sitesi ve online başvuru formları, e-posta, fiziki veya elektronik belgeler, sözleşmeler, eğitim ve mentorluk süreçleri, toplantılar, değerlendirme ve jüri süreçleri, anketler, etkinlikler, kullanılan bilgi sistemleri ve program kapsamında gerçekleştirilen diğer iletişim kanalları aracılığıyla otomatik veya otomatik olmayan yöntemlerle elde edilebilmektedir."
  },
  {
    "type": "paragraph",
    "text": "İTK Starter’a iletmiş olduğunuz yahut İTK Starter tarafından edinilen kişisel verilerinizin; kişisel veriyi edinme amaçları dışında kullanılmadığını, açık rızanız veya KVKK Madde 5’te yer alan istisnai hallerden herhangi birinin varlığı söz konusu olmaksızın kişisel verilerinizin işlenmediğini, üçüncü kişilere aktarılmadığını ve bu konuda uygun güvenlik düzeyini temin etmeye yönelik gerekli her türlü idari ve teknik tedbirlerin alındığını beyan ederiz."
  },
  {
    "type": "paragraph",
    "text": "Kanunda yer alan diğer kişisel veri işleme şartlarının bulunmadığı ve açık rızanın gerekli olduğu veri işleme faaliyetleri bakımından açık rızanız ayrıca talep edilir."
  },
  {
    "type": "heading",
    "text": "Kişisel Verilerinizi Hangi Amaçla ve Kimlere Aktarmaktayız?"
  },
  {
    "type": "paragraph",
    "text": "Kişisel verileriniz, KVKK’nın 8 inci ve 9 uncu maddelerine uygun olarak ve yukarıda belirtilen amaçlarla sınırlı olmak üzere;"
  },
  {
    "type": "bullet",
    "text": "İTK Starter programının yürütülmesinde görev alan yetkili İTK çalışanları ve ilgili İTK kampüsleri,"
  },
  {
    "type": "bullet",
    "text": "Program kapsamında görev alan eğitmen, mentor, jüri üyeleri ve Değerlendirme Komitesi üyeleri,"
  },
  {
    "type": "bullet",
    "text": "İTK Starter online platformuna ilgili yetkiler kapsamında erişimi bulunan program katılımcıları,"
  },
  {
    "type": "bullet",
    "text": "Program ve araştırma süreçlerinin yürütülmesi için hizmet alınan hizmet sağlayıcılar,"
  },
  {
    "type": "bullet",
    "text": "Araştırma projesinin niteliğine ve gerekli izinlere bağlı olarak iş birliği yapılan üniversite, akademik kurum veya diğer proje paydaşları,"
  },
  {
    "type": "bullet",
    "text": "Gerekli olması halinde yatırım değerlendirme süreçleri kapsamında İTK Ventures ve ilgili yetkili kişiler,"
  },
  {
    "type": "bullet",
    "text": "Hukuki yükümlülüklerin yerine getirilmesi amacıyla yetkili kamu kurum ve kuruluşları ile yargı mercileri"
  },
  {
    "type": "paragraph",
    "text": "ile paylaşılabilir."
  },
  {
    "type": "paragraph",
    "text": "Katılımcılara ait proje ve fikirler, İTK Starter online platformunda programın işleyişine uygun erişim yetkileri çerçevesinde lise öğrencileri, çalışanlar ve program yürütücülerince görüntülenebilir. Proje ve fikirlerin program dışındaki üçüncü kişilerle paylaşılması, ilgili sözleşme ve izin süreçlerine tabidir."
  },
  {
    "type": "paragraph",
    "text": "Tanıtım ve iletişim faaliyetleri kapsamında proje/araştırma bilgisi veya benzeri kişisel verilerin İTK'nın internet sitesi, sosyal medya hesapları veya diğer kamuya açık iletişim kanallarında paylaşılması ancak ilgili hukuki şartların sağlanması halinde gerçekleştirilir."
  },
  {
    "type": "paragraph",
    "text": "Program kapsamında kullanılan Google, Microsoft veya benzeri dijital hizmetlerin ya da diğer altyapı sağlayıcıların yurt dışında bulunan sistem ve sunucularının kullanılması nedeniyle kişisel verilerin yurt dışına aktarılmasının söz konusu olması halinde, aktarım KVKK’nın 9 uncu maddesinde öngörülen yurt dışına aktarım şart ve mekanizmalarından ilgili olanı sağlanarak gerçekleştirilir."
  },
  {
    "type": "heading",
    "text": "Kişisel Verileriniz ile İlgili KVKK’nın 11. Maddesinde Düzenlenen Haklarınız"
  },
  {
    "type": "paragraph",
    "text": "KVKK’nın 11 inci maddesi uyarınca, veri sorumlusu İTK Starter’a başvurarak:"
  },
  {
    "type": "number",
    "text": "Kişisel verilerinizin işlenip işlenmediğini öğrenme,",
    "number": 1
  },
  {
    "type": "number",
    "text": "Kişisel verileriniz işlenmiş ise buna ilişkin bilgi talep etme,",
    "number": 2
  },
  {
    "type": "number",
    "text": "Kişisel verilerinizin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,",
    "number": 3
  },
  {
    "type": "number",
    "text": "Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,",
    "number": 4
  },
  {
    "type": "number",
    "text": "Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme,",
    "number": 5
  },
  {
    "type": "number",
    "text": "KVKK’da öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme,",
    "number": 6
  },
  {
    "type": "number",
    "text": "Düzeltme, silme veya yok etme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,",
    "number": 7
  },
  {
    "type": "number",
    "text": "İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,",
    "number": 8
  },
  {
    "type": "number",
    "text": "Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme",
    "number": 9
  },
  {
    "type": "paragraph",
    "text": "haklarına sahipsiniz."
  },
  {
    "type": "contact",
    "text": "KVKK’nın 11 inci maddesi kapsamındaki haklarınızı kullanmak için, innovationhub@itk.k12.tr adresine yazılı olarak başvuruda bulunabilirsiniz."
  },
  {
    "type": "paragraph",
    "text": "İTK Starter, yürütülen veri işleme faaliyetlerinde veya ilgili mevzuatta meydana gelebilecek değişikliklere bağlı olarak işbu Aydınlatma Metnini güncelleyebilir."
  },
  {
    "type": "paragraph",
    "text": "İTK Starter"
  }
];

export default function KvkkPage() {
  return (
    <main className="min-h-screen bg-[#eef5ff]">
      <InnovationHubHeader />
      <div className="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
        <header className="mb-6 rounded-2xl bg-white px-5 py-7 shadow-sm sm:mb-8 sm:px-9 sm:py-10">
          <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#e8f2ff] text-[#1565C0]">
            <ShieldCheck size={26} aria-hidden="true" />
          </div>
          <h1 className="max-w-3xl text-2xl font-bold leading-tight text-[#173b7a] sm:text-3xl lg:text-4xl">
            İTK STARTER KİŞİSEL VERİLERİN İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ
          </h1>
        </header>

        <article className="rounded-2xl bg-white px-5 py-7 shadow-sm sm:px-9 sm:py-10">
          <div className="space-y-4 text-[15px] leading-7 text-slate-700 sm:text-base sm:leading-8">
            {content.map((item, index) => {
              if (item.type === "heading") {
                return (
                  <h2 key={index} className="pt-5 text-lg font-bold leading-snug text-[#173b7a] first:pt-0 sm:text-xl">
                    {item.text}
                  </h2>
                );
              }
              if (item.type === "bullet") {
                return <p key={index} className="relative pl-6 before:absolute before:left-1 before:top-3 before:h-2 before:w-2 before:rounded-full before:bg-[#1565C0]">{item.text}</p>;
              }
              if (item.type === "number") {
                return (
                  <div key={index} className="flex items-start gap-3">
                    <span className="mt-1 flex h-7 min-w-7 shrink-0 items-center justify-center rounded-full bg-[#e8f2ff] px-1 text-xs font-semibold text-[#1565C0]">{item.number}</span>
                    <p className="min-w-0 flex-1">{item.text}</p>
                  </div>
                );
              }
              if (item.type === "emphasis") {
                return <p key={index} className="break-words font-bold text-[#173b7a]">{item.text}</p>;
              }
              if (item.type === "contact") {
                return (
                  <div key={index} className="rounded-xl border border-blue-100 bg-[#f8fbff] p-4 sm:p-5">
                    <p>{item.text.split("innovationhub@itk.k12.tr")[0]}<a className="inline-flex items-center gap-1 break-all font-semibold text-[#1565C0] underline underline-offset-4 hover:text-[#0f4f99]" href="mailto:innovationhub@itk.k12.tr"><Mail size={16} aria-hidden="true" />innovationhub@itk.k12.tr</a>{item.text.split("innovationhub@itk.k12.tr")[1]}</p>
                  </div>
                );
              }
              return <p key={index}>{item.text}</p>;
            })}
          </div>
        </article>
      </div>
      <InnovationHubFooter />
    </main>
  );
}
